export default __webpack_public_path__ + "static/media/wingu-logo.9771ea7e.png";